












import { userService } from '@/services';
import Vue from 'vue';

export default Vue.extend({
  name: 'Test',

  data: () => ({
    status: 500,
    statusAfter: 200,
    delay: 0,
    per: 0
  }),

  methods: {
    async test(): Promise<void> {
      await userService.test(this.status, this.delay, this.statusAfter, this.per);
    },

    async getUsers(): Promise<void> {
      const users = await userService.getUsers();
      console.log(users);
    }
  }
});
